import { FormItemStyled, FormStyled } from "fwork.react.apptemplate";
import React, { useState } from "react";
import { HeaderComponent } from "../common/header";
import { DEFAULTGAP } from "../../globals";
import { FormStyledProps } from "fwork.react.apptemplate/src/components/forms";
import { ICompany_group, ICompanyGroup } from "bets.oddprovider.lib.common.ts/models";
import { DropDownSearchComponent } from "../common/dropDownSearch";
import { FaTrash } from "react-icons/fa";
import { CompaniesGroupsApiClient } from "../../apiClient/companiesGroups";
import axios from "../../apiClient/axios";
import { useSnackbar } from "notistack";
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient";
import { Autocomplete } from "@mui/material";
import { AutocompleteClientComponent } from 'fwork-react-mui-ext/src'

export interface CompanyGroupsComponentProps extends FormStyledProps {
  data?: ICompany_group[],
  onSelectItem?: ((item: ICompany_group, group: ICompanyGroup) => void) | undefined,
  onDeleteItem?: (item: ICompany_group) => void,
  onAddItem?: () => void,
}

export const CompanyGroupsComponent: React.FC<CompanyGroupsComponentProps> = ({ data, onSelectItem, onDeleteItem, onAddItem, ...props }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [gettingCompaniesGroups, setGettingCompaniesGroups] = useState<boolean>()

  const getCompaniesGroups = async (filter: string) => {
    if (gettingCompaniesGroups) return
    setGettingCompaniesGroups(true)

    try {
      const response = await new CompaniesGroupsApiClient(axios).get({
        where: {
          name: { $regex: filter, $options: 'i' }
        },
        sort: { name: 1 }
      })
      return response.data?.payload
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingCompaniesGroups(false)
    }
  }

  return <FormStyled gap={props.gap ?? DEFAULTGAP} {...props} >
    <FormItemStyled gap={DEFAULTGAP} fullWidth>
      <HeaderComponent
        title='Grupos'
        onAddClick={onAddItem}
      />
    </FormItemStyled>

    {data?.map((c_g, idx) => <FormItemStyled key={idx} gap={DEFAULTGAP}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        rowGap: DEFAULTGAP,
        columnGap: DEFAULTGAP,
      }}>
      <AutocompleteClientComponent
        style={{width: '100%'}}
        inputValueKeyName="name"
        initKeyValue={c_g?.group?.name}
        onChangeItem={(data?: ICompanyGroup | null) => {
          if (onSelectItem && data)
            onSelectItem(c_g, data)
        }}
        onGetData={async (filter: string, key: boolean) => {
          const response = await new CompaniesGroupsApiClient(axios).get({
            where: {
              name: { $regex: filter, $options: 'i' }
            },
            sort: { name: 1 }
          })
          return response.data?.payload
        }}
        textFieldProps={{
          label: 'Grupo de trabalho'
        }}
      />
      {/* <DropDownSearchComponent
        id={`DropDownSearchComponent${idx}`}
        initInputValue={c_g?.group?.name || ''}
        progress={gettingCompaniesGroups}
        style={{ width: '100%' }}
        label="Grupo"
        modelLabelName="name"
        dataBuilder={async (typedText: string | undefined) => {
          if (typedText)
            return await getCompaniesGroups(typedText)
        }}
        onSelectItem={(userGroup: ICompanyGroup) => {
          if (onSelectItem)
            onSelectItem(c_g, userGroup)
        }}
      /> */}
      <FaTrash style={{ cursor: 'pointer', }} color='grey' size={20} onClick={() => {
        if (onDeleteItem)
          onDeleteItem(c_g)
      }} />
    </FormItemStyled>)}
  </FormStyled>
}